var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "#073C50",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9339815,3.3980549 L2.74517889,8.69988969 C1.77193637,9.06793853 1.78978531,9.59120356 2.5790311,9.83273206 L6.21081222,10.9310944 L14.6374678,5.79020379 C15.029106,5.53716318 15.3910727,5.68092348 15.0943598,5.93396409 L8.27592447,11.9028804 L8.01479369,15.5314239 C8.39460985,15.5314239 8.56075764,15.3703675 8.75657707,15.1806151 L10.5309451,13.5245077 L14.2101886,16.1524572 C14.880749,16.5204499 15.3614016,16.3306975 15.5394291,15.5486639 L17.9546865,4.51938519 C18.1683548,3.5532711 17.5927198,3.16803843 16.9339815,3.3980549 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.64f2a90400cd738dc529a604b95edfd0.svg";
export { ForwardRef as ReactComponent };